import { useEffect, useState } from "react";
import CommentForm from "./CommentForm";
import CommentsList from "./CommentsList";
import cls from "./styles.module.css";
import type { TRespondTarget } from "./CommentForm/typings";

type TProps = {
  postId: number;
  commentsCount: number;
};
export default function PostCommentsSection(props: TProps) {
  const [respondTarget, setRespondTarget] = useState<TRespondTarget | null>(
    null,
  );
  const resetRespondTarget = () => setRespondTarget(null);
  useEffect(() => {
    setRespondTarget(null);
  }, [props.postId]);
  return (
    <section className={cls.root}>
      <h2 className={cls.header}>Комментарии</h2>
      {props.commentsCount > 0 && (
        <CommentsList
          postId={props.postId}
          changeRespondTarget={setRespondTarget}
        />
      )}
      <CommentForm
        postId={props.postId}
        respondTarget={respondTarget}
        resetRespondTarget={resetRespondTarget}
      />
    </section>
  );
}
